import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./Details.module.sass";
import Icon from "../../../components/Icon";
import Head from "./Head";
import Editor from "../../../components/Editor";
import { EditorState, ContentState } from "draft-js";

const Details = ({ className, onClose, contactRequest }) => {
  const [content, setContent] = useState(() => EditorState.createEmpty());

  // Effet pour initialiser le contenu avec le message de la demande
  useEffect(() => {
    if (contactRequest?.message) {
      const contentState = ContentState.createFromText(contactRequest.message);
      const editorState = EditorState.createWithContent(contentState);
      setContent(editorState);
    } else {
      setContent(EditorState.createEmpty());
    }
  }, [contactRequest]);

  // Fonction pour formater la date
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className={cn(styles.details, className)}>
      <button className={styles.close} onClick={onClose}>
        <Icon name="close" size="20" />
      </button>
      <Head className={styles.head} contactRequest={contactRequest} />
      
      {contactRequest ? (
        <>
          <Editor
            state={content}
            onChange={setContent}
            classEditor={styles.editor}
            label="Message"
            tooltip="Message de la demande"
          />
          

        
        
        </>
      ) : (
        <div className={styles.noSelection}>
          Sélectionnez une demande de contact pour voir les détails
        </div>
      )}
    </div>
  );
};

export default Details;
